export function bar(ctx) {
    return {
        styles: {
            main:      { bg_color: ctx.COLOR_BG_SEC, bg_opa: 255, radius: 999, border_width: 0 },  // #d4d7d9
            indicator: { bg_color: ctx.primary, radius: 999 },
        },
    };
}
